import React, { useContext, useEffect, useState } from "react";
import { CiLogout, CiMail } from "react-icons/ci";
import { FiFacebook } from "react-icons/fi";
import { LuAlignJustify, LuPhone } from "react-icons/lu";
import { TiUserOutline } from "react-icons/ti";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ThemeContext } from "../App";
import ClientAuthContext from "../context/ClientAuthContext";
import "../css/header.scss";
import enIcon from "../data/icons/en.png";
import mnIcon from "../data/icons/mn.png";

const Header = ({ title, data }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { userData, setUserData } = useContext(ClientAuthContext);
  const { setLanguage, language } = useContext(ThemeContext);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [clientMenuOpen, setClientMenuOpen] = useState(false);
  const isLoggedIn = !!userData?.id;
  const { innerWidth: width } = window;
  const bucket = "msid-asset";
  const region = "ap-northeast-2";

  const toggleNavbar = () => {
    if (isCollapsed) {
      setClientMenuOpen(false);
    }
    setIsCollapsed(!isCollapsed);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (isCollapsed) {
        setIsCollapsed(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
  }, [isCollapsed]);

  const logout = () => {
    localStorage.removeItem("msidclienttoken");
    localStorage.removeItem("msidMemberModalShown");
    setClientMenuOpen(false);
    setUserData({});
    navigate("/");
  };

  function toggleMenu() {
    setClientMenuOpen(!clientMenuOpen);
  }

  const goToClientPage = () => {
    navigate("/client");
    setIsCollapsed(false);
    setClientMenuOpen(false);
  };

  return (
    <div className="header">
      <section className="topper">
        <div className="topper-inner">
          <div className="top-menu-item">
            <LuPhone size={20} className="icons" color="white" />
            <span>{data.phoneNum}</span>
          </div>
          <div className="top-menu-item">
            <CiMail size={20} className="icons" color="white" />
            <span>{data.mailAddress}</span>
          </div>
          <div className="top-menu-item hide-xs">
            <FiFacebook size={20} className="icons" color="white" />
            <Link
              to={`${data.facebookAddress}`}
              target="_blank"
              className="fb-link"
            >
              <p>msid</p>
            </Link>
          </div>
          <div
            className="lang-menu"
            onClick={() => {
              setLanguage(!language);
              localStorage.setItem("msid_app_lang", language ? "MN" : "EN");
              setIsCollapsed(false);
            }}
          >
            <img
              alt={language ? "en" : "mn"}
              src={language ? mnIcon : enIcon}
              className="languageIcon"
            />
          </div>
        </div>
      </section>

      <nav id="menu-bar" className="menu-bar">
        <Link className="title-logo" to="/#home">
          <img
            alt="logo"
            className="logo"
            src="/images/logo.png"
            height={64}
            width={64}
          />
          <div className="title">{title}</div>
        </Link>

        <button
          type="button"
          className="navbar-toggler collapsed"
          onClick={toggleNavbar}
          aria-controls="navbarNav"
          aria-expanded={isCollapsed}
          aria-label="Toggle navigation"
        >
          <LuAlignJustify color="black" size={25} />
        </button>

        <div id="menu-items" className="menu-items">
          <Link
            className="nav-link"
            to="/#home"
            onClick={() => setIsCollapsed(false)}
          >
            {data.home}
          </Link>
          <Link
            className="nav-link"
            to="/clinics"
            onClick={() => setIsCollapsed(false)}
          >
            {data.clinics}
          </Link>
          <Link
            className="nav-link"
            to="/doctors"
            onClick={() => setIsCollapsed(false)}
          >
            {data.doctors}
          </Link>
          <Link
            className="nav-link"
            to="/events"
            onClick={() => setIsCollapsed(false)}
          >
            {data.events}
          </Link>
          <Link
            className="nav-link"
            to="/annual-meetings"
            onClick={() => setIsCollapsed(false)}
          >
            {data.annualMeetings}
          </Link>

          {isLoggedIn ? (
            <div className="nav-link client-menu" onClick={toggleMenu}>
              <span className="user-name">
                {userData?.fileUrl ? (
                  <img
                    src={`https://${bucket}.s3.${region}.amazonaws.com/${userData.fileUrl}`}
                    alt="user"
                    style={{
                      width: "25px",
                      height: "25px",
                      borderRadius: "50%",
                      objectFit: "cover",
                      marginRight: "5px",
                    }}
                  />
                ) : (
                  <TiUserOutline size={25} />
                )}
                {userData?.first_name}
              </span>
              {clientMenuOpen ? (
                <div className="client-dropdown">
                  <div className="dropdown-item">
                    <Link to="/client" onClick={() => goToClientPage()}>
                      <span className="menu-icon">
                        <TiUserOutline size={15} />
                      </span>
                      <span className="menu-text">Миний мэдээлэл</span>
                    </Link>
                  </div>
                  <div className="dropdown-item">
                    <Link to="/membership" onClick={() => setIsCollapsed(false)}>
                      <span className="menu-icon">
                        <TiUserOutline size={15} />
                      </span>
                      <span className="menu-text">Гишүүнчлэл</span>
                    </Link>
                  </div>
                  <div
                    className="dropdown-item padding"
                    onClick={() => logout()}
                  >
                    <CiLogout size={15} />
                    <span className="menu-text">Вебсайтаас гарах</span>
                  </div>
                </div>
              ) : null}
            </div>
          ) : (
            <>
              <Link
                className="nav-link"
                to="/signup"
                onClick={() => setIsCollapsed(false)}
              >
                {data.signup}
              </Link>
              <Link
                className="nav-link"
                to="/client/signin"
                state={{ from: location }}
                onClick={() => setIsCollapsed(false)}
              >
                <span className="dark">{data.signin}</span>
              </Link>
            </>
          )}
        </div>

        <div
          id="navbarNav"
          className={`sm-menu-items ${isCollapsed ? "" : "hidden"}`}
        >
          <Link
            className="nav-link"
            to="/#home"
            onClick={() => setIsCollapsed(false)}
          >
            {data.home}
          </Link>
          <Link
            className="nav-link"
            to="/clinics"
            onClick={() => setIsCollapsed(false)}
          >
            {data.clinics}
          </Link>
          <Link
            className="nav-link"
            to="/doctors"
            onClick={() => setIsCollapsed(false)}
          >
            {data.doctors}
          </Link>
          <Link
            className="nav-link"
            to="/events"
            onClick={() => setIsCollapsed(false)}
          >
            {data.events}
          </Link>
          <Link
            className="nav-link"
            to="/annual-meetings"
            onClick={() => setIsCollapsed(false)}
          >
            {data.annualMeetings}
          </Link>
          {isLoggedIn ? (
            <>
              <Link
                className="nav-link"
                to="/client"
                onClick={() => goToClientPage()}
              >
                Миний мэдээлэл
              </Link>
              <a className="nav-link" onClick={() => logout()}>
                <span>Вебсайтаас гарах</span>
              </a>
            </>
          ) : (
            <>
              <Link
                className="nav-link"
                to="/signup"
                onClick={() => setIsCollapsed(false)}
              >
                {data.signup}
              </Link>
              <Link
                className="nav-link"
                to="/client/signin"
                state={{ from: location }}
                onClick={() => setIsCollapsed(false)}
              >
                <span className="dark">{data.signin}</span>
              </Link>
            </>
          )}
        </div>
      </nav>
    </div>
  );
};

export default Header;